<template>
  <div class="col-12">
    <fieldset class="border border-3 p-2" v-bind:style="[error ? { 'box-shadow': '0 .125rem 1rem red!important' } : '']">
      <legend class="float-none w-auto px-3 text-start">Venku</legend>
      <div class="row">
        <div class="col-2 offset-1 text-center">Zahrada<br/><span style="font-size: 3rem">{{ temp }}<sup class="small-c">°C</sup></span></div>
        <div class="col-1 text-center">
          <br/>
          <span style="font-size: 3rem">
                          <img style="height: 2rem" v-if="direction === 'up'" :src="up" />
                          <img style="height: 2rem" v-if="direction === 'down'" :src="down" />
                          <img style="width: 1.8rem" v-if="direction === 'stale'" :src="stale" />
                        </span>
        </div>
        <div class="col-2 text-center">Střecha<br/><span style="font-size: 3rem">{{ temp }}<sup class="small-c">°C</sup></span></div>
        <div class="col-1 text-center">
          <br/>
          <span style="font-size: 3rem">
                          <img style="height: 2rem" v-if="direction === 'up'" :src="up" />
                          <img style="height: 2rem" v-if="direction === 'down'" :src="down" />
                          <img style="width: 1.8rem" v-if="direction === 'stale'" :src="stale" />
                        </span>
        </div>
        <div class="col-2 offset-1 text-center">Nejnižší<br/><span style="font-size: 3rem">{{ minTemp }}<sup class="small-c">°C</sup></span>
        </div>
        <div class="col-2 text-center">Nejnižší<br/><span style="font-size: 3rem">{{ maxTemp }}<sup class="small-c">°C</sup></span></div>
      </div>
    </fieldset>
  </div>
</template>

<script>
export default {
  name: "VenkovniTeplota",
  data() {
    return {
      temp: 0,
      fetchInterval: null,
      minTemp: 0,
      maxTemp: 0,
      error: false,
      direction: "stale",
      down: require('@/assets/DOWN.svg'),
      up: require('@/assets/UP.svg'),
      stale: require('@/assets/STALE.svg')
    }
  },
  methods: {
    fetchTemp() {
      this.$http.get(this.$apiUrl + "/room/e2a39dc0-944a-4261-9b8e-14e57d2f270d/temperature")
          .then(response => {
            this.temp = response.data.temperature
            this.error = response.data.error
            this.direction = response.data.direction
          })
      this.$http.get(this.$apiUrl + "/room/e2a39dc0-944a-4261-9b8e-14e57d2f270d/range")
          .then(response => {
            this.minTemp = response.data.minTemperature
            this.maxTemp = response.data.maxTemperature
          })
    }
  }
  ,
  mounted() {
    this.fetchTemp()
    this.fetchInterval = setInterval(this.fetchTemp, 60000)
  }
}
</script>

<style scoped>

</style>